import { sendBi } from '../../services/bi/send-request';
import { BIEventIds } from '../../services/bi/event-ids';
export const sendUploadCoverEvent = data => {
  sendBi('/mg', {
    src: 26,
    evid: BIEventIds.BIEventsIds.responseTime,
    call_name: 'boards.cover.upload',
    response_time: Math.round(data.responseTime || 0),
    response_size: Math.round(data.responseSize || 0),
    response_speed: data.responseTime > 0 && Math.round(data.responseSize / (data.responseTime / 1000)),
    result: data.isSuccess ? 'success' : 'fail'
  });
};